import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    Box,
    Grid,
    Typography,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow, TableCell, TableBody, Dialog, DialogContent, DialogTitle, DialogActions
} from '@mui/material';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { tr } from 'date-fns/locale';
import {API_URL} from "./config";
import ShiftCalendar from "./components/ShiftCalendar";
import Header from "./components/Header";
import moment from "moment";
import {DeleteForever, EditNote, Save} from "@mui/icons-material";
import Footer from "./components/Footer";

const DashBoard = () => {
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [notes, setNotes] = useState("");
  const [savedDates, setSavedDates] = useState([]);
  const [deleteDialog,setDeleteDialog] = useState(false)
  const [shiftId,setShiftId] = useState(false)


  useEffect(() => {
          let doctorId=JSON.parse(localStorage.getItem('ac_id'))
      let token = JSON.parse(localStorage.getItem("ac_auth_token"));
    // API'den daha önce kaydedilmiş tarihleri çek
    axios.get(`${API_URL}/shifts/${doctorId}`, {
        headers: {
          Accept: "application/json",
              Authorization: `Bearer ${token}`,
      }}
        )
      .then(response => setSavedDates(response.data))
      .catch(error => console.error('Error fetching dates:', error));
  }, []);

const handleSubmit = () => {
    if (startDateTime && endDateTime) {
        const shiftStartDate = new Date(startDateTime.getTime() - startDateTime.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0];

        const shiftEndDate = new Date(endDateTime.getTime() - endDateTime.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0];
      const startHour = startDateTime.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', hour12: false });
      const endHour = endDateTime.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', hour12: false });
      let doctorId=JSON.parse(localStorage.getItem('ac_id'))
      const data = {
        shift_start_date: shiftStartDate,
        shift_end_date: shiftEndDate,
        start_hour: startHour,
        end_hour: endHour,
        doctor_id: doctorId,
        notes:notes
      };
        let token = JSON.parse(localStorage.getItem("ac_auth_token"));
      axios.post(`${API_URL}/shift`, data,{
          headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
          },
      })
        .then(response => {
          console.log('Dates saved:', response.data);
          setSavedDates([...savedDates, data]);
          window.location.reload();
        })
        .catch(error => console.error('Error saving dates:', error));
    } else {
      alert('Lütfen tarih alanlarının ikisini de doldurunuz.')
    }
  };

    function handleDelete() {
        let token = JSON.parse(localStorage.getItem("ac_auth_token"));
        let data = {shift_id:shiftId}
        axios.post(`${API_URL}/delete-shift`, data, {
            headers: {
            Accept: "application/json",
                Authorization: `Bearer ${token}`,
        }}
            )
            .then(response => {
                console.log('Dates deleted:', response.data);
                window.location.reload()
             })
            .catch(error => console.error('Error saving dates:', error));
    }

    return (
      <>
          <Header />

      <div>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
          <Box sx={{p: 2}}>
            <Typography variant="h6">Tarih ve Saat Seçimi</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                  <DateTimePicker
                      label="Başlangıç Tarihi ve Saati"
                      value={startDateTime}
                      onChange={setStartDateTime}
                      minDate={new Date()} // Geçmiş tarihlerin seçilmesini engeller

                      renderInput={(props) => (
                          <TextField
                              {...props}
                              fullWidth
                              inputProps={{
                                  ...props.inputProps,
                                  readOnly: true, // Manuel girişleri devre dışı bırakır
                              }}
                              onKeyDown={(e) => e.preventDefault()} // Klavye girişlerini engeller
                          />
                      )}
                  />
              </Grid>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                    label="Bitiş Tarihi ve Saati"
                    value={endDateTime}
                    onChange={setEndDateTime}
                    minDate={new Date()} // Geçmiş tarihlerin seçilmesini engeller

                    renderInput={(props) => (
                        <TextField
                            {...props}
                            fullWidth
                            inputProps={{
                                ...props.inputProps,
                                readOnly: true, // Manuel girişleri devre dışı bırakır
                            }}
                            onKeyDown={(e) => e.preventDefault()} // Klavye girişlerini engeller
                        />
                    )}
                />
              </Grid>
                <Grid item xs={12} md={4}>
                    <TextField fullWidth={true} placeholder={'Notlar'}
                            onChange={(e)=>{setNotes(e.target.value)}}
                    />
                </Grid>
            </Grid>
            <Box sx={{mt: 2}}>
              <Button variant="contained" color="success" onClick={handleSubmit}> <Save />
                Kaydet
              </Button>
            </Box>
            <Box sx={{mt: 4}}>
              <Typography variant="h6">Kaydedilen Tarihler</Typography>

                <Grid container>

                    <Grid md={8} sm={12} xs={12}> <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 350 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell align="left">Başlangıç Tarihi - Saati</TableCell>
                                    <TableCell align="left">Bitiş Tarihi - Saati</TableCell>
                                    <TableCell align="left">Not</TableCell>
                                    <TableCell align="left">Sil</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Bu kısımda daha önce kaydedilen tarihleri gösterecek bir bileşen olmalı */}
                                {savedDates.map((date, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {index+1}
                                        </TableCell>
                                        <TableCell align="left">
                                            {moment(date.shift_start_date).format('DD/MM/YYYY')} - {date.start_hour}
                                        </TableCell>
                                        <TableCell align="left">
                                            {moment(date.shift_end_date).format('DD/MM/YYYY')} - {date.end_hour}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {date.notes}
                                        </TableCell>
                                        <TableCell align="left">
                                            <Button onClick={()=>{setDeleteDialog(true); setShiftId(date.id)}}   title={'Sil'}><DeleteForever color={'error'} /></Button>
                                        </TableCell>

                                    </TableRow>

                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer></Grid>
                    <Grid md={4} sm={12} xs={12}>  <ShiftCalendar shifts={savedDates} />
                    </Grid>

                </Grid>


            </Box>

          </Box>
        </LocalizationProvider>

      </div>
  <div>            <Box sx={{mt: 4}}>

  </Box>
      <Dialog open={deleteDialog}  >
          <DialogTitle>
            Silme Onayı
          </DialogTitle>
          <DialogContent>
            Bu tarihi silmek istediğinize emin misiniz?
          </DialogContent>
          <DialogActions>
              <Button onClick={()=>{setDeleteDialog(false)}}>İptal</Button>
              <Button color={'error'} onClick={handleDelete}>Sil</Button>
          </DialogActions>
      </Dialog>
      <Footer />
      </div>
</>
  );
};

export default DashBoard;
